import {
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
} from "@mui/material";
import React from "react";

const AutreCompetenceNiveau = ({
  getValue,
  value,
  typeCompetence = "autre",
  onChange,
  error = false,
  helperText = "",
}) => {
  const [niveau, setNiveau] = React.useState(String(value).split(",") || []);
  const [type, setType] = React.useState(["Excellent", "Moyen", "Débutant"]);
  const linguistiques = ["langue", "linguistique", "langues", "linguistiques"];

  React.useEffect(() => {
    if (getValue) getValue(() => niveau);
    if (value) setNiveau(value);
  }, [getValue, value]);

  const handleChange = (event, value) => {
    if (linguistiques.includes(typeCompetence.toLocaleLowerCase())) {
      let newNiveau;
      if (event.target.checked) {
        newNiveau = [...niveau, value];
      } else {
        newNiveau = niveau.filter((item) => item !== value);
      }
      newNiveau = newNiveau.filter((item) => item !== "");
      setNiveau(newNiveau.sort((a, b) => a - b));
      //   onSetNiveauState && onSetNiveauState(newNiveau);
      onChange(newNiveau.sort((a, b) => a - b).join(","));
    } else {
      const newNiveau = event.target.checked ? [value] : [];
      setNiveau(newNiveau.sort((a, b) => a - b));
      //   onSetNiveauState && onSetNiveauState(newNiveau);
      onChange(newNiveau.sort((a, b) => a - b).join(","));
    }
  };

  React.useEffect(() => {
    if (typeCompetence) {
      setType(
        linguistiques.includes(typeCompetence.toLocaleLowerCase())
          ? ["lire", "écrire", "parler"]
          : ["Débutant", "Moyen", "Excellent"]
      );
    }
  }, [typeCompetence]);

  React.useEffect(() => {
    if (type) {
      setNiveau([]);
    }
  }, [type]);
  return (
    <Grid
      display={"flex"}
      justifyContent={"center"}
      flexDirection={"column"}
      mt={1}
    >
      <Grid item display={"flex"} justifyContent={"center"}>
        {type.map((item, index) => (
          <FormControlLabel
            onChange={(event) => handleChange(event, item)}
            checked={niveau.includes(item)}
            key={index}
            control={
              <Checkbox name="niveau" color={error ? "error" : "primary"} />
            }
            label={item}
          />
        ))}
      </Grid>
      <FormHelperText
        id="niveau_helper"
        sx={{ color: error ? "error.main" : "unset" }}
      >
        {helperText}
      </FormHelperText>
    </Grid>
  );
};

export default AutreCompetenceNiveau;
